export default "__VITE_ASSET__rUDsVh50__"